import { render, staticRenderFns } from "./TableInspectColumn7.vue?vue&type=template&id=12b9c7ce&scoped=true&"
import script from "./TableInspectColumn7.vue?vue&type=script&lang=js&"
export * from "./TableInspectColumn7.vue?vue&type=script&lang=js&"
import style0 from "./TableInspectColumn7.vue?vue&type=style&index=0&id=12b9c7ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9c7ce",
  null
  
)

export default component.exports